<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header></Header>
    <b-container fluid>
      <b-row v-if="idPaciente != null">
        <b-col>
          <pacientev2 :vistaCompleta="false" :propIdPaciente="idPaciente"></pacientev2>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <HojaDiagnosticoDescentralizadoComponente
          titulo="Validación PTI"
          :subtitulo="'Diagnóstico'"
          :codigo="'CA_03_19'"
          @idPaciente="paciente"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "@/components/Header";
import HojaDiagnosticoDescentralizadoComponente from "@/components/hojasDiagnostico/HojaDiagnosticoDescentralizadoComponente";
import pacientev2 from "@/views/PacienteV2";
export default {
  name: "ValidacionPTI",
  data() {
    return{
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
     idPaciente : null
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  components: {HojaDiagnosticoDescentralizadoComponente, Header,pacientev2},
  methods:{
    paciente(data){
      this.idPaciente = data
    }
  }
}
</script>

<style scoped>

</style>